var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var SolicitationCodeNode_1;
import { NonNegativeIntResolver } from "graphql-scalars";
import { Field, ObjectType, registerEnumType } from "type-graphql";
import { Node } from "../relay.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { TimestampedResource } from "./Resource.js";
export const SolicitationCodeTag = {
    MiniMarathon: "MiniMarathon",
    DancerTeam: "DancerTeam",
    Active: "Active",
    General: "General",
};
export const solicitationCodeTagColors = {
    MiniMarathon: "#90b",
    DancerTeam: "#33f",
    Active: "#30d048",
    General: "#950",
};
export const solicitationCodeTagWeight = {
    MiniMarathon: 101,
    DancerTeam: 102,
    Active: 0,
    General: 50,
};
export function stringifySolicitationCodeTag(tag) {
    switch (tag) {
        case SolicitationCodeTag.MiniMarathon: {
            return "Mini Marathons";
        }
        case SolicitationCodeTag.DancerTeam: {
            return "Dancer Team";
        }
        default: {
            return tag;
        }
    }
}
export function sortSolicitationCodeTags(tags) {
    return tags.toSorted((a, b) => {
        return solicitationCodeTagWeight[a] - solicitationCodeTagWeight[b];
    });
}
registerEnumType(SolicitationCodeTag, {
    name: "SolicitationCodeTag",
    description: "The tags for a solicitation code",
});
let SolicitationCodeNode = SolicitationCodeNode_1 = class SolicitationCodeNode extends TimestampedResource {
    id;
    prefix;
    code;
    name;
    tags;
    text() {
        if (!this.name) {
            return `${this.prefix}${this.code.toString().padStart(4, "0")}`;
        }
        else {
            return `${this.prefix}${this.code.toString().padStart(4, "0")} - ${this.name}`;
        }
    }
    getUniqueId() {
        return this.id.id;
    }
    static init(init) {
        return SolicitationCodeNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], SolicitationCodeNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], SolicitationCodeNode.prototype, "prefix", void 0);
__decorate([
    Field(() => NonNegativeIntResolver, { nullable: false }),
    __metadata("design:type", Number)
], SolicitationCodeNode.prototype, "code", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], SolicitationCodeNode.prototype, "name", void 0);
__decorate([
    Field(() => [SolicitationCodeTag], { nullable: false }),
    __metadata("design:type", Array)
], SolicitationCodeNode.prototype, "tags", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], SolicitationCodeNode.prototype, "text", null);
SolicitationCodeNode = SolicitationCodeNode_1 = __decorate([
    ObjectType({
        implements: [Node],
    })
], SolicitationCodeNode);
export { SolicitationCodeNode };
//# sourceMappingURL=SolicitationCode.js.map